var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var StyledThead = styled.thead(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > tr th {\n    border-spacing: 0;\n    border-bottom: 1px solid #aeb3b7;\n    padding-bottom: 5px;\n  }\n"], ["\n  & > tr th {\n    border-spacing: 0;\n    border-bottom: 1px solid #aeb3b7;\n    padding-bottom: 5px;\n  }\n"])));
var templateObject_1;
